// ex: HFB '01', PRA '012', PA '0123'
export const isSubsetOfHfb = (praOrPa, hfbOrPra) => {
  if (!hfbOrPra || !praOrPa) {
    return true
  }
  return praOrPa.startsWith(hfbOrPra)
}
